export default class AccordionHtml {
    constructor(items, multiple, targetContainer = '') {
        this._items = items;
        this._multiple = multiple;
        this._targetContainer = targetContainer;
        // eslint-disable-next-line no-undef
    }

    _getItemHtml() {
        let itemsHtml = '';

        this._items.forEach((item) => {
            itemsHtml += AccordionHtml.getHeadHtml(item) + AccordionHtml.getContentHtml(item);
        });

        return itemsHtml;
    }

    static getHeadHtml(item) {
        return `
            <div class="rfct-accordion__item-head" tabindex="0" role="tab">
                <span class="rfct-accordion__item-head-label">${item.title}</span>
            </div>
        `;
    }

    static getContentHtml(item) {
        return `
            <div class="rfct-accordion__item-body">
                <div class="rfct-accordion__item-body-content">
                    ${item.content}
                </div>
            </div>
        `;
    }

    static getMultipleHtml() {
        // eslint-disable-next-line no-undef
        let $globalConfig;
        if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
            $globalConfig = config;
        }
        return `
            <div class="rfct-accordion__controls">
                <div class="rfct-accordion__controls-col">
                    <button class="rfct-accordion__control-button rfct-accordion__control-button--open-all rfct-accordion__control-button--active">${$globalConfig.textResources.productCatalogConnectorConfig.accordionOpenAllButtonText}</button>
                </div>
                <div class="rfct-accordion__controls-col">
                    <button class="rfct-accordion__control-button rfct-accordion__control-button--close-all rfct-accordion__control-button--active">${$globalConfig.textResources.productCatalogConnectorConfig.accordionCloseAllButtonText}</button>
                </div>
            </div>
        `;
    }

    toString() {
        const classList = `rfct-accordion${this._multiple ? ' rfct-accordion--multi' : ''}${this._targetContainer !== '' ? ' rfct-accordion--horizontal' : ''}`;
        const targetContainer = this._targetContainer !== '' ? `data-horizontal-target-container-selector="${this._targetContainer}"` : '';

        return `
            <div class="${classList}" ${targetContainer} role="tablist">
                ${this._multiple ? AccordionHtml.getMultipleHtml() : ''}
                <div class="rfct-accordion__content">
                    ${this._getItemHtml()}
                </div>
            </div>
        `;
    }
}
